import { getAuthHeaders, tempMeeApi } from '~/services/api';
import { IUpdateCandidateStatusPayload } from '../types';

export const updateCandidateStatus = async (
  payload: IUpdateCandidateStatusPayload,
): Promise<void> => {
  const headers = await getAuthHeaders();
  await tempMeeApi.patch<void>(
    `/recruitment-service/candidates/status`,
    {
      candidateIds: payload.candidateIds,
      status: payload.status,
    },
    {
      headers,
    },
  );
};
